import { useState, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { getIndicadoresDenuncias, getIndicadoresEstado, getIndicadoresFrecuencia } from '../api/informesApi'

export const useIndicadores = (trigger, reportData, periodoData, contrato) => {
  const [data, setData] = useState({
    denuncias: null,
    estado: null,
    frecuencia: null,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!trigger || !contrato || !reportData?.fechaDesde || !reportData?.fechaHasta || !periodoData?.fechaHasta) return

    const controller = new AbortController()
    const signal = controller.signal

    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const [denunciasRes, estadoRes, frecuenciaRes] = await Promise.all([
          getIndicadoresDenuncias(contrato, reportData.fechaDesde, reportData.fechaHasta, { signal }),
          getIndicadoresEstado(contrato, reportData.fechaDesde, reportData.fechaHasta, { signal }),
          getIndicadoresFrecuencia(contrato, periodoData.fechaHasta, { signal }),
        ])

        setData({
          denuncias: denunciasRes.data,
          estado: estadoRes.data,
          frecuencia: frecuenciaRes.data,
        })
      } catch (error) {
        if (error.name === 'CanceledError') return
        Sentry.captureException(error)
        setData({ denuncias: null, estado: null, frecuencia: null })
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
    return () => controller.abort()
  }, [trigger, contrato, reportData?.fechaDesde, reportData?.fechaHasta, periodoData?.fechaHasta])

  return { data, isLoading, error }
}
